import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Chat from './icon-chat.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Chat {...validProps} />;
}
SvgComponent.iconName = 'chat';

/**
 * @deprecated This is a legacy icon
 */
export const ChatIcon = svgIconWrapper(SvgComponent);
